import React, { useState } from 'react';
import { SERVER_URL } from '../config';

const PasswordPage = ({ onPasswordSubmit }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const credentials = btoa(`user:${password}`);
      const response = await fetch(`${SERVER_URL}/nodes`, {
        method: 'GET',
        headers: {
          'Authorization': `Basic ${credentials}`,
        },
      });
    
      if (response.ok) {
        const data = await response.json();
        const nodes = Array.isArray(data) ? data : [];
        onPasswordSubmit(credentials, nodes);
      } else if (response.status === 401) {
        setError('Incorrect password. Please try again.');
      } else {
        setError(`An error occurred (${response.status}). Please try again later.`);
      }
    } catch (err) {
      console.log(err);
      setError('An error occurred. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      {isLoading && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10,
        }}>
          <div className="spinner"></div> {/* Spinner element */}
        </div>
      )}
      <h2>Enter Password</h2>
      <form onSubmit={handlePasswordSubmit} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          style={{ padding: '10px', fontSize: '16px', margin: '10px 0' }}
          disabled={isLoading} // Disable input while loading
        />
        <button type="submit" style={{ padding: '10px 20px', fontSize: '16px' }} disabled={isLoading}>
          Submit
        </button>
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </form>
    </div>  );
};

export default PasswordPage;